import Api from "../api/api";

export default async (id) => {
  return await Api.post(`notification/delete/${id}`);
};
